// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_EuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Lens_Lens from "../Data.Lens.Lens/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Ring from "../Data.Ring/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
var VecIsSymbol = {
    reflectSymbol: function () {
        return "Vec";
    }
};
var Vec = /* #__PURE__ */ (function () {
    function Vec(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Vec.create = function (value0) {
        return function (value1) {
            return new Vec(value0, value1);
        };
    };
    return Vec;
})();
var genericVec_ = {
    to: function (x) {
        return new Vec(x.value0, x.value1);
    },
    from: function (x) {
        return new Data_Generic_Rep.Product(x.value0, x.value1);
    }
};
var genericShow = /* #__PURE__ */ Data_Show_Generic.genericShow(genericVec_);
var showVec = function (dictShow) {
    var genericShowArgsArgument = Data_Show_Generic.genericShowArgsArgument(dictShow);
    return {
        show: genericShow(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsProduct(genericShowArgsArgument)(genericShowArgsArgument))(VecIsSymbol))
    };
};
var functorVec = {
    map: function (f) {
        return function (m) {
            return new Vec(f(m.value0), f(m.value1));
        };
    }
};
var foldableVec = {
    foldr: function (f) {
        return function (b) {
            return function (v) {
                return f(v.value0)(f(v.value1)(b));
            };
        };
    },
    foldl: function (f) {
        return function (b) {
            return function (v) {
                return f(f(b)(v.value0))(v.value1);
            };
        };
    },
    foldMap: function (dictMonoid) {
        return Data_Foldable.foldMapDefaultL(foldableVec)(dictMonoid);
    }
};
var traversableVec = {
    traverse: function (dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply = Control_Apply.apply(Apply0);
        var map = Data_Functor.map(Apply0.Functor0());
        return function (f) {
            return function (v) {
                return apply(map(Vec.create)(f(v.value0)))(f(v.value1));
            };
        };
    },
    sequence: function (dictApplicative) {
        return Data_Traversable.sequenceDefault(traversableVec)(dictApplicative);
    },
    Functor0: function () {
        return functorVec;
    },
    Foldable1: function () {
        return foldableVec;
    }
};
var eqVec = function (dictEq) {
    var eq = Data_Eq.eq(dictEq);
    return {
        eq: function (x) {
            return function (y) {
                return eq(x.value0)(y.value0) && eq(x.value1)(y.value1);
            };
        }
    };
};
var ordVec = function (dictOrd) {
    var compare = Data_Ord.compare(dictOrd);
    var eqVec1 = eqVec(dictOrd.Eq0());
    return {
        compare: function (x) {
            return function (y) {
                var v = compare(x.value0)(y.value0);
                if (v instanceof Data_Ordering.LT) {
                    return Data_Ordering.LT.value;
                };
                if (v instanceof Data_Ordering.GT) {
                    return Data_Ordering.GT.value;
                };
                return compare(x.value1)(y.value1);
            };
        },
        Eq0: function () {
            return eqVec1;
        }
    };
};
var applyVec = {
    apply: function (v) {
        return function (v1) {
            return new Vec(v.value0(v1.value0), v.value1(v1.value1));
        };
    },
    Functor0: function () {
        return functorVec;
    }
};
var lift2 = /* #__PURE__ */ Control_Apply.lift2(applyVec);
var applicativeVec = {
    pure: function (x) {
        return new Vec(x, x);
    },
    Apply0: function () {
        return applyVec;
    }
};
var pure = /* #__PURE__ */ Control_Applicative.pure(applicativeVec);
var semiringVec = function (dictSemiring) {
    return {
        add: lift2(Data_Semiring.add(dictSemiring)),
        zero: pure(Data_Semiring.zero(dictSemiring)),
        mul: lift2(Data_Semiring.mul(dictSemiring)),
        one: pure(Data_Semiring.one(dictSemiring))
    };
};
var ringVec = function (dictRing) {
    var semiringVec1 = semiringVec(dictRing.Semiring0());
    return {
        sub: lift2(Data_Ring.sub(dictRing)),
        Semiring0: function () {
            return semiringVec1;
        }
    };
};
var vmod = function (dictEuclideanRing) {
    var mod = Data_EuclideanRing.mod(dictEuclideanRing);
    return function (v) {
        return function (v1) {
            return new Vec(mod(v.value0)(v1.value0), mod(v.value1)(v1.value1));
        };
    };
};
var vec = /* #__PURE__ */ (function () {
    return Vec.create;
})();
var vdiv = function (dictEuclideanRing) {
    var div = Data_EuclideanRing.div(dictEuclideanRing);
    return function (v) {
        return function (v1) {
            return new Vec(div(v.value0)(v1.value0), div(v.value1)(v1.value1));
        };
    };
};
var unVec = function (f) {
    return function (v) {
        return f(v.value0)(v.value1);
    };
};
var two = function (dictSemiring) {
    var one = Data_Semiring.one(dictSemiring);
    return Data_Semiring.add(dictSemiring)(one)(one);
};
var twice = function (dictEuclideanRing) {
    var Semiring0 = ((dictEuclideanRing.CommutativeRing0()).Ring0()).Semiring0();
    var mul = Data_Semiring.mul(Semiring0);
    var two1 = two(Semiring0);
    return function (v) {
        return new Vec(mul(v.value0)(two1), mul(v.value1)(two1));
    };
};
var swap = function (v) {
    return new Vec(v.value1, v.value0);
};
var setY = function (y) {
    return function (v) {
        return new Vec(v.value0, y);
    };
};
var setX = function (x) {
    return function (v) {
        return new Vec(x, v.value1);
    };
};
var oneY = function (dictSemiring) {
    return new Vec(Data_Semiring.zero(dictSemiring), Data_Semiring.one(dictSemiring));
};
var oneX = function (dictSemiring) {
    return new Vec(Data_Semiring.one(dictSemiring), Data_Semiring.zero(dictSemiring));
};
var modifyY = function (f) {
    return function (v) {
        return new Vec(v.value0, f(v.value1));
    };
};
var modifyX = function (f) {
    return function (v) {
        return new Vec(f(v.value0), v.value1);
    };
};
var half = function (dictEuclideanRing) {
    var div = Data_EuclideanRing.div(dictEuclideanRing);
    var two1 = two(((dictEuclideanRing.CommutativeRing0()).Ring0()).Semiring0());
    return function (v) {
        return new Vec(div(v.value0)(two1), div(v.value1)(two1));
    };
};
var getY = function (v) {
    return v.value1;
};
var getX = function (v) {
    return v.value0;
};
var _y = function (dictStrong) {
    return Data_Lens_Lens.lens(getY)(Data_Function.flip(setY))(dictStrong);
};
var _x = function (dictStrong) {
    return Data_Lens_Lens.lens(getX)(Data_Function.flip(setX))(dictStrong);
};
export {
    Vec,
    vec,
    oneX,
    oneY,
    unVec,
    getX,
    getY,
    swap,
    vdiv,
    vmod,
    half,
    twice,
    setX,
    setY,
    modifyX,
    modifyY,
    _x,
    _y,
    genericVec_,
    eqVec,
    ordVec,
    functorVec,
    foldableVec,
    traversableVec,
    showVec,
    semiringVec,
    ringVec,
    applicativeVec,
    applyVec
};
